import React, { Fragment, useEffect, useState } from 'react';
import MultiCarousel from '../../MultiCarouselElements/MultiCarousel';
import MultiCarouselArrows from '../../MultiCarouselElements/MultiCarouselArrows';
import { UpdateConfiguratorValue } from '../../../Actions/Configurator/Configurator.action';
import { useSelector, useDispatch } from 'react-redux';
import LightboxImages from '../../LightboxImages';
import { translate } from '../../../Services/translation'; 
import { ConfiguratorConstants } from '../../../Models/Configurator/ConfiguratorConstants';

const ProductListModule = (props) => {
    const dispatch = useDispatch();
    const [selectedArticleNumber, setselectedArticleNumber] = useState("");
    const { configuratorValues } = useSelector((state) => state.productConfigurator.payload);
    const [isClickedLink, setIsClickedLink] = useState(false);
    const [currentThumbnailIndex, setcurrentThumbnailIndex] = useState(0);

    const handleOnClickLink = () => {
        setIsClickedLink(true);
    };

    useEffect(() => {
        if (props.moduleInfo && configuratorValues.find(x => x.name === props.moduleInfo.moduleProperty)) {
            setselectedArticleNumber(configuratorValues.find(x => x.name === props.moduleInfo.moduleProperty).value);
        }
    }, [configuratorValues, configuratorValues.map(x => x.value), configuratorValues.length]);
    
    const handleScroll = () => {
        const moduleTitle = document.getElementById("wallProductSectionTitle");
        const offset = moduleTitle.getBoundingClientRect().top;
        window.scrollBy({
            top: offset - 80,
            left: 0,
            behavior: 'smooth' 
        });
    };


    let responsive = {
        desktop: {
            breakpoint: { max: 9999, min: 1024 },
            items: 4,
            slidesToSlide: 2,
            partialVisibilityGutter: 0
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 2,
            slidesToSlide: 2,
            partialVisibilityGutter: 0
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1,
            slidesToSlide: 1,
            partialVisibilityGutter: 120
        }
    };

    const settings = {
        swipeable: true,
        draggable: false,
        showDots: false,
        responsive: responsive,
        containerClass: ``,
        itemClass: ``,
        keyBoardControl: true,
        infinite: false,
        arrows: false,
        customButtonGroup: <MultiCarouselArrows cssBlock={""} color={""} buttonColor={""} />,
        renderButtonGroupOutside: true,
        partialVisible: props.moduleInfo.products.length > 1
    }

    const children = (items) => {        
        return (
            items.map((item, index) => {
                return (
                    <div className="configurator__product-wrapper">
                        <div className={selectedArticleNumber === item.id ? "configurator__product-list-selected" : "product__item"}>
                            <a key={item.id} onClick={() => {
                                    dispatch(UpdateConfiguratorValue(props.moduleInfo.moduleProperty, item.id));
                                    dispatch(UpdateConfiguratorValue(ConfiguratorConstants.MaxHeight, item.maxHeight)); 
                                    handleScroll();
                                }}>
                                {item.campaignTag && item.campaignTag.isActive &&
                                    <div className="campaign-tag" style={{ backgroundColor: item.campaignTag.backgroundColor, width: item.campaignTag.tagSize, boxShadow: item.campaignTag.shadow}}>
                                        <div className="campaign-tag__text" style={{ color: item.campaignTag.textColor}} dangerouslySetInnerHTML={{__html: item.campaignTag.text}}>
                                        </div>
                                    </div>
                                }
                                <div className='product__image'>
                                    <img src={item.lightBoxLazyLoadImagesUrl[0].src}/>
                                </div>
                                <p className='product__name'>{item.name}</p>
                                {item.price.campaignPrice && item.price.campaignPrice.priceWithVat ? (
                                    <div>
                                        <p className='configurator__price-campaign'>{item.price.campaignPrice && item.price.campaignPrice.priceWithVat ? `${item.price.campaignPrice.priceWithVat} ${item.currencyCode ? item.currencyCode : "kr"} / ${item.unitOfMeasurement}` : 0}
                                        <span className='configurator__old-price'>{item.price.hasPrice ? `${item.price.price.priceWithVat} ${item.currency.symbol ? item.currency.symbol : "kr"} / ${item.unitOfMeasurement}` : 0}</span></p>
                                    </div>
                                ) : (
                                    <p className='product__price'>{item.price.hasPrice ? `${item.price.price.priceWithVat} ${item.currency.symbol ? item.currency.symbol : "kr"} / ${item.unitOfMeasurement}` : 0}</p>
                                )}
                            </a>
                        </div>                        
                        {selectedArticleNumber === item.id ? 
                            <div className='product__thumbnails'>
                                <a onClick={handleOnClickLink}>{translate("configuratorProductShowImages")}</a>
                                {isClickedLink && (
                                     <div>
                                        <LightboxImages
                                            showThumbnails={true}
                                            showImageCount={false}
                                            images={item.lightBoxLazyLoadImagesUrl}
                                            thumbnails={item.lightBoxLazyLoadImagesUrl.map((item) => (item.thumbnail))}
                                            onClose={() => {setIsClickedLink(false); setcurrentThumbnailIndex(0);}}
                                            isOpen={true}
                                            hideCarousel={true}
                                            onClickThumbnail={(itemIndex) => setcurrentThumbnailIndex(itemIndex)}
                                            currentImage={currentThumbnailIndex}
                                            onClickPrev={() => setcurrentThumbnailIndex(currentThumbnailIndex - 1 >= 0 ? currentThumbnailIndex - 1 : 0)}
                                            onClickNext={() => setcurrentThumbnailIndex(currentThumbnailIndex + 1)}
                                        />                                        
                                    </div>
                                )}
                            </div>
                            : ""
                        }
                    </div>)
            }));        
    };

    return (
        <div className="configurator__product-list">
            <div className='content-wrapper'>
                <h3 className='title' id="wallProductSectionTitle">{props.moduleInfo.title}</h3>
                <div className='text' dangerouslySetInnerHTML={{__html: props.moduleInfo.text}}></div>
                <div className='item-scroll'>
                    {
                        <MultiCarousel settings={settings} children={children(props.moduleInfo.products)} items={props.moduleInfo.products} cssBlock={""} color={""} 
                        buttonColor={""}/>
                    } 
                </div>                       
            </div>
        </div>
        
    );
}

export default ProductListModule;